import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { jqlBuilderWithAiEntryPoint } from '@atlassian/jira-jql-builder-with-ai/src/ui/entrypoint.tsx';

export const issueNavigatorEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-project-issue-navigator-entrypoint" */ './src'),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		const issueKey = entryPointParams?.context?.query?.selectedIssue;

		let preloadProps = {};
		// exclude nativeIssueTableEntryPoint and jqlBuilderWithAiEntryPoint from preloading on the issue route
		if (!issueKey) {
			preloadProps = {
				entryPoints: {
					nativeIssueTableEntryPoint: {
						entryPoint: nativeIssueTableEntryPoint,
						entryPointParams,
					},
					...(fg('jql_builder_basic_ssr_stability_fixes')
						? {
								jqlBuilderWithAiEntryPoint: {
									entryPoint: jqlBuilderWithAiEntryPoint,
									entryPointParams,
								},
							}
						: {}),
				},
			};
		}

		return preloadProps;
	},
});
